<template>
	<div class="congratulations">
		<close theme="dark" @close="$emit('close')"></close>

		<div class="title">{{ t('title') }}</div>

		<div class="body">{{ t('subtitle') }}</div>

		<a
			@click.prevent="
				openExternalUrl(
					`https://api.simple.life/workbook/${user_id}/Healthy%20Eating/${language.toUpperCase()}_Simple_Guide_to_Eating_Well.pdf`
				)
			"
			href=""
			class="btn btn-primary btn-block"
			>{{ t('nutrition_button') }}</a
		>
		<a
			@click.prevent="
				openExternalUrl(`https://api.simple.life/workbook/${user_id}/Workout/${language.toUpperCase()}_Workout.pdf`)
			"
			href=""
			class="btn btn-primary btn-block"
			>{{ t('workout_button') }}</a
		>

		<div class="note">
			{{ t('note') }}
		</div>
	</div>
</template>

<script>
import Close from '@/components/Close.vue'
import useApi from '@/composition/api.js'
import { useI18n } from 'vue-i18n'
import { computed } from '@vue/reactivity'

export default {
	props: ['user_id'],

	components: {
		Close
	},

	setup() {
		const api = useApi()

		const { t, locale } = useI18n({
			messages: {
				en: {
					title: 'Congratulations',
					subtitle: 'You can now download workbooks',
					nutrition_button: 'DOWNLOAD HEALTHY EATING',
					workout_button: 'DOWNLOAD YOUR WORKOUT',
					note: "Please make sure you've downloaded both workbooks before closing this screen. You won't be able to download them after."
				},
				de: {
					title: 'Glückwunsch!',
					subtitle: 'Du kannst deine Workbooks jetzt herunterladen.',
					nutrition_button: 'ERNÄHRUNGS-WORKBOOK HERUNTERLADEN',
					workout_button: 'TRAININGS-WORKBOOK HERUNTERLADEN',
					note: 'Bitte schließe dieses Fenster erst, wenn du beide Workbooks heruntergeladen hast. Danach kannst du die Dateien leider nicht mehr herunterladen.'
				},
				es: {
					title: '¡Enhorabuena!',
					subtitle: 'Ya puedes descargar las guías interactivas',
					nutrition_button: 'GUÍA PARA COMER SANO',
					workout_button: 'GUÍA DE ENTRENAMIENTO',
					note: 'Antes de cerrar esta pantalla, asegúrate de descargar las dos guías, ya que no podrás hacerlo más adelante.'
				},
				fr: {
					title: 'Félicitations !',
					subtitle: 'Vous pouvez désormais télécharger vos cahiers.',
					nutrition_button: 'MON CAHIER DE NUTRITION',
					workout_button: "MON CAHIER D'ENTRAÎNEMENT",
					note: "Veuillez télécharger les deux cahiers avant de fermer cette fenêtre. Vous n'aurez pas la possibilité de le faire ultérieurement."
				},
				it: {
					title: 'Congratulazioni!',
					subtitle: 'Ora, puoi scaricare le guide',
					nutrition_button: "GUIDA A UN'ALIMENTAZIONE SANA",
					workout_button: "GUIDA ALL'ALLENAMENTO",
					note: 'Prima di chiudere la schermata, accertati di aver scaricato entrambe le guide, poiché non potrai farlo in seguito.'
				},
				pt: {
					title: 'Parabéns!',
					subtitle: 'Baixe agora os guias',
					nutrition_button: 'BAIXE O GUIA ALIMENTAÇÃO SAUDÁVEL',
					workout_button: 'BAIXE O GUIA DE TREINOS',
					note: 'É necessário baixar os dois guias antes de fechar esta tela, pois não será possível baixar posteriormente.'
				},
				ru: {
					title: 'Поздравляем!',
					subtitle: 'Руководства доступны для скачивания',
					nutrition_button: 'Руководство по здоровому питанию',
					workout_button: 'Руководство по тренировкам',
					note: 'Пожалуйста, убедитесь, что вы загрузили оба руководства, прежде чем закрыть это уведомление. Скачать их позднее будет невозможно.'
				}
			}
		})

		const language = computed(() => locale.value)

		const openExternalUrl = (url) => api.openExternalURL(url)

		return {
			t,
			openExternalUrl,
			language
		}
	}
}
</script>

<style lang="scss" scoped>
.title {
	text-align: center;
	font-weight: bold;
	font-size: 1.8rem;
}

.body {
	margin-top: 20px;
	text-align: center;
	font-size: 1.1rem;
	padding-bottom: 1rem;

	b {
		display: block;
		margin-top: 15px;
		word-wrap: break-word;
		line-height: 1.4;
	}
}

.btn {
	margin-top: 10px;
	font-size: 1rem;
}

.note {
	margin-top: 20px;
	padding: 0 20px;
	text-align: center;
}
</style>
